/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import RedLogo from '../../assets/svg/RedLogo';
import { EventType, useAnalytics } from '../Analytics';
import { AppleButton } from '../../assets/svg/walletIcons/AppleButton';
import { GoogleButton } from '../../assets/svg/walletIcons/GoogleButton';
import { useLocation } from 'react-router-dom';
import { current } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCardLockStatusRequest } from '@rb-serve-app/core';
import { environment } from '@rb-serve-app/core';
import AccountDetails from '../../components/AccountDetails';
import LegalPrivacyModal from '../../components/LegalPrivacyModal';

type Props = {
  siteDown?: any;
  contentfulData: any;
  featureFlaggingData: any;
  setShowFeatureFlagMessage: React.Dispatch<React.SetStateAction<boolean>>;
  assetsData: any;
};

const Footer = ({
  siteDown = false,
  contentfulData,
  featureFlaggingData,
  setShowFeatureFlagMessage,
  assetsData,
}: Props) => {
  console.log('siteDown', siteDown, siteDown == true);
  const [isLegalPrivacyModalVisible, setIsLegalPrivacyModalVisible] =
    useState(false);
  const { trackEvent } = useAnalytics();
  const [toggleDetails, setToggleDetails] = useState(false);
  const [hasTracked, setHasTracked] = useState(false); // Flag to prevent repeated tracking
  const location = useLocation();
  const dispatch = useDispatch();
  const { customerId, accountId, accountDetails } = useSelector(
    (state: any) => state.user
  );
  const { status: cardLockStatus } = useSelector(
    (state: any) => state.cardLock
  );
  useEffect(() => {
    if (accountId && customerId && accountDetails !== null) {
      dispatch(fetchCardLockStatusRequest({ accountId, customerId }));
    }
  }, [dispatch, accountId, customerId]);
  const cardAuthorizationStatus =
    cardLockStatus?.cardControlPrefData?.cardAuthorizationStatus?.active;

  const trackClickEvent = () => {
    const name = 'see full details';
    let currentPage = '';
    if (window.location.pathname.split('/')[1] === 'equal-payment-plan') {
      currentPage = 'view equal payment plans';
    } else if (window.location.pathname.split('/')[1] === 'transactions') {
      currentPage = 'transactions history';
    } else if (window.location.pathname.split('/')[1] === 'lock-unlock') {
      if (cardAuthorizationStatus === false) {
        currentPage = 'card is locked';
      } else if (cardAuthorizationStatus === true) {
        currentPage = 'card is unlocked';
      }
    } else {
      currentPage = `${window.location.pathname.split('/')[1]}`;
    }
    if (currentPage !== '' && !hasTracked) {
      trackEvent(
        EventType.CLICK_EVENT,
        currentPage,
        window.location.href,
        `${currentPage} | ${name}`
      );
      setHasTracked(true);
      sessionStorage.setItem('hasTrackedSeeFullDetails', 'true');
    }
  };

  useEffect(() => {
    const storedTrackingFlag = sessionStorage.getItem(
      'hasTrackedSeeFullDetails'
    );
    if (storedTrackingFlag === 'true') {
      setHasTracked(true);
    } else {
      setHasTracked(false);
    }
    return () => {
      sessionStorage.removeItem('hasTrackedSeeFullDetails');
    };
  }, [location.pathname]);

  const featureFlag = () => {
    if (window.scrollY !== 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
    setShowFeatureFlagMessage(true);
    setTimeout(() => setShowFeatureFlagMessage(false), 3000);
  };

  const openLegalPrivacyModal = () => {
    setIsLegalPrivacyModalVisible(true);
  };

  const handlePrivacyClick = () => {
    window.open(
      contentfulData?.rb_links?.rbLinksCollection?.privacy_policy,
      '_blank'
    );
  };

  const handleContactUsClick = () => {
    window.open(
      contentfulData?.rb_links?.rbLinksCollection?.contact_us,
      '_blank'
    );
  };

  const handleAccessibilityClick = () => {
    window.open(
      contentfulData?.rb_links?.rbLinksCollection?.accessibility_link,
      '_blank'
    );
  };

  const coorpUserLogin = environment.coorpUserLoginUrl;
  return (
    <footer
      className={`${siteDown ? 'bg-[#1F1F1F]  mx-0 px-5' : 'bg-[#FAFAFA]  mx-5'} mt-auto text-black text-md pt-0 border-t-[1px] border-slate-200`}
    >
      <div className="border-b-[1px] border-slate-200 p-1">
        <div
          className="flex justify-between flex-row"
          onClick={() => {
            setToggleDetails(!toggleDetails);
            trackClickEvent();
          }}
        >
          <button
            className={` ${siteDown ? 'text-[#FFFFFF]' : 'text-black'} text-[12px] font-[600]`}
            aria-expanded={toggleDetails}
            aria-controls="details-section"
          >
            {contentfulData?.rb_footer?.seeFullDetailsTitle}
          </button>
          <button
            aria-label={toggleDetails ? 'Hide Details' : 'Show Details'}
            className="w-6 h-6"
          >
            {toggleDetails ? (
              <img
                src={assetsData?.up_arrow}
                alt="upArrow"
                role="button"
                color="#fff"
              />
            ) : (
              <img
                src={assetsData?.down_arrow}
                alt="downArrow"
                role="button"
                color="#fff"
              />
            )}
          </button>
        </div>
        {toggleDetails && (
          <div
            id="details-section"
            className={`mt-2 space-y-2 text-[12px] text-gray-800 ${siteDown && 'text-white'}`}
          >
            <p>{contentfulData?.rb_footer?.footerDescriptionOne}</p>
            <p>{contentfulData?.rb_footer?.footerDescriptionTwo}</p>
          </div>
        )}
      </div>

      <div className="flex flex-col md:flex-row justify-between md:items-center sm:items-start mt-2">
        <div className="space-x-1 text-left md:text-left">
          <p
            className={`${
              featureFlaggingData?.footer?.privacy_notice
                ? siteDown
                  ? 'text-white'
                  : 'text-gray-800'
                : siteDown
                  ? 'text-white'
                  : 'text-gray-400'
            } inline text-[12px] cursor-pointer`}
            aria-label="Contact Us"
            onClick={handleContactUsClick}
          >
            {contentfulData?.rb_footer?.contactUsLink} |
          </p>
          {/* <p
            className={`${featureFlaggingData?.footer?.privacy_notice
              ? (siteDown ? 'text-white' : 'text-gray-800')
              : (siteDown ? 'text-white' : 'text-gray-400')} inline text-[12px] cursor-pointer`}
            aria-label="Privacy Notice"
            onClick={handlePrivacyClick}
          >
            {contentfulData?.rb_footer?.privacyNoticeLink} |
          </p> */}
          <p
            className={`${
              featureFlaggingData?.footer?.privacy_notice
                ? siteDown
                  ? 'text-white'
                  : 'text-gray-800'
                : siteDown
                  ? 'text-white'
                  : 'text-gray-400'
            } inline text-[12px] cursor-pointer`}
            aria-label="Accessibility"
            onClick={handleAccessibilityClick}
          >
            {contentfulData?.rb_footer?.accessibilityLink} |
          </p>
          <p
            className={`${
              featureFlaggingData?.footer?.privacy_notice
                ? siteDown
                  ? 'text-white'
                  : 'text-gray-800'
                : siteDown
                  ? 'text-white'
                  : 'text-gray-400'
            } inline text-[12px] cursor-pointer`}
            aria-label="Legal"
            onClick={openLegalPrivacyModal}
          >
            {contentfulData?.rb_footer?.legalLink} |
          </p>
          {isLegalPrivacyModalVisible && (
            <LegalPrivacyModal
              isLegalPrivacyModalOpen={isLegalPrivacyModalVisible}
              setIsLegalPrivacyModalOpen={setIsLegalPrivacyModalVisible}
            />
          )}
          <p
            className={`inline text-[12px] ${siteDown ? 'text-white' : 'text-primary-red'} cursor-pointer hover:underline`}
            aria-label="coorp-user"
            onClick={() => {
              const language = localStorage?.getItem('language');
              let params = 'en_CA';
              if (language == 'fr') {
                params = 'fr_CA';
              } else {
                params = 'en_CA';
              }
              window.open(`${coorpUserLogin}&locale=${params}`, '_blank');
            }}
          >
            {
              contentfulData?.rb_signin?.signinIdentityVerification
                ?.corp_footer_content
            }
          </p>
          <img
            src={assetsData?.dot_icon}
            alt="dotIcon"
            className="inline w-[6px] h-[7px] "
          />
          <p
            className={`inline text-[12px] ${siteDown ? 'text-white' : 'text-gray-800'}`}
            aria-label="CopyRight"
          >
            {contentfulData?.rb_footer?.footerCopyRights}
          </p>
        </div>
        <div className="mt-2 md:mt-0">
          {siteDown ? (
            <img
              src={assetsData?.rb_logo_white}
              alt={contentfulData?.headerLogoAltText}
              width={145}
              height={18}
            />
          ) : (
            // <RedLogo />
            <img
              src={assetsData?.rb_footer_logo}
              alt={contentfulData?.headerLogoAltText}
              width={145}
              height={18}
            />
          )}
        </div>
      </div>
      {contentfulData && location.pathname === '/sign-in' && (
        <div className="flex gap-2 mt-3">
          <div
            onClick={() => {
              window.open(
                'https://apps.apple.com/us/app/rogers-bank/id1527119582',
                '_blank'
              );
            }}
          >
            <AppleButton />
          </div>
          <div
            onClick={() => {
              window.open(
                'https://play.google.com/store/apps/details?id=com.rogers.banking',
                '_blank'
              );
            }}
          >
            <GoogleButton />
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
